import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import {arrayHasEmptyStrings} from "../common/utils";
import {setEmailConfirmationCode, validateEmailConfirmationCode} from "../actionCreators/appAC";

const EmailValidationModal = () => {
    const dispatch = useDispatch();
    const dismiss = () => dispatch({
        type: 'SHOW_EMAIL_VALIDATION',
        show_email_validation: false,
        show_email_validation_success: false,
        show_email_validation_error: false
    });

    const [token, setToken] = useState(['','','','']);
    const user_profile = useSelector((state) => state.myAccountReducer.user_profile);
    const email_validation_error_message = useSelector((state) => state.appReducer.email_validation_error_message);

    const inputRefs = [
        useRef(),
        useRef(),
        useRef(),
        useRef()
    ]

    useEffect(() => {
        const handlePasteAnywhere = event => {
            const token_value = event.clipboardData.getData('text');

            if (token_value.length === 4) {
                setToken([token_value[0],token_value[1],token_value[2],token_value[3]]);
            }
        };

        window.addEventListener('paste', handlePasteAnywhere);

        return () => {
            window.removeEventListener('paste', handlePasteAnywhere);
        };
    }, [])

    useEffect(() => {
        if(inputRefs[0].current){
            inputRefs[0].current.focus();
        }
    }, [token])

    const addToToken = (idx, digit) => {
        const is_valid_digit = typeof digit !== 'undefined';
        let new_token = [...token];
        new_token[idx] = is_valid_digit ? digit : '';
        if (idx < 3) {
            if (is_valid_digit) {
                setTimeout(() => {
                    inputRefs[idx+1].current.focus();
                }, 0);
            }
        }
        setToken(new_token);
    }

    const resendCode = () => {
        dispatch(setEmailConfirmationCode(true));
        setToken(['','','','']);
    }

    const confirmToken = () => {
        dispatch(validateEmailConfirmationCode(token.join('')));
    }

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={dismiss}
            className="email-confirm-modal rbg-popup-generic"
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            <Modal.Header className="rbg-popup-generic__header">
                <Button
                    className="rbg-popup-generic__close-icon"
                    onClick={dismiss}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body">
                <div className="email-confirm-modal__content">
                    <div className="email-confirm-modal__title">
                        We’ve sent a code to
                    </div>
                    <div className="email-confirm-modal__phone-nr">
                        {user_profile.email}
                    </div>
                    <div className="email-confirm-modal__text email-confirm-modal__text--grey">
                        Please enter the code below
                    </div>
                    <div className="email-confirm-modal__code-input-container">
                        {inputRefs.map((ref, idx) => {
                            return (
                                <NumberFormat
                                    key={idx}
                                    getInputRef={ref}
                                    displayType={'input'}
                                    name={`token-${idx}`}
                                    allowNegative={false}
                                    pattern="\d"
                                    format='#'
                                    value={token[idx]}
                                    onValueChange={(e) => addToToken(idx, e.floatValue)}
                                    className="email-confirm-modal__code-input"
                                />
                            )
                        })}
                    </div>
                    {email_validation_error_message &&
                        <div className="cart-popup__discount-error">
                            {email_validation_error_message}
                        </div>
                    }
                    <div className="email-confirm-modal__button-container">
                        <Button
                            variant="clean"
                            className="email-confirm-modal__resend"
                            onClick={resendCode}
                        >
                            Resend Code
                        </Button>
                    </div>
                    <div className="email-confirm-modal__button-container">
                        <Button
                            variant="secondary"
                            className="btn-black email-confirm-modal__cta"
                            disabled={!arrayHasEmptyStrings(token)}
                            onClick={confirmToken}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EmailValidationModal;